import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import PaymentSuccess from "@/pages/checkout/pay-success/PaymentSuccess/PaymentSuccess";
import queryString from "query-string";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useLocation } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import useWebview from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import { useEnhancedPromoSystem } from "@/_MiniApps/customized_promo_codes/hooks/useEnhancedPromoSystem";
var CheckoutSuccess = function CheckoutSuccess() {
  var checkoutOrderV2 = useCheckoutOrder().state.checkoutOrderV2;
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    order_id = _useCheckoutOrder$que.order_id,
    post_id = _useCheckoutOrder$que.post_id;
  var fetch__getOrderWithPaymentInfoV2 = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfoV2;
  var location = useLocation();
  var _useSession = useSession(),
    user = _useSession.user;
  var webview = useWebview();
  var isWebview = useIsWebView();
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var _useEnhancedPromoSyst = useEnhancedPromoSystem(),
    getPromoEventParams = _useEnhancedPromoSyst.getPromoEventParams,
    promoCode = _useEnhancedPromoSyst.promoCode,
    getPromoCodeDataForTracking = _useEnhancedPromoSyst.getPromoCodeDataForTracking;
  useEffect(function () {
    webview.setBackButtonScreen("post_details")["catch"](function () {
      // please keep the catch
    });
    if (!post_id && !order_id) return;
    fetch__getOrderWithPaymentInfoV2(post_id, {
      order_id: order_id || undefined
    });
  }, [post_id, order_id]);
  useEffect(function () {
    var _checkoutOrderV2$g4_d, _checkoutOrderV2$id, _checkoutOrderV2$deta, _checkoutOrderV2$deta2, _checkoutOrderV2$deta3;
    if (!checkoutOrderV2) return;
    var search = location.search;
    var values = queryString.parse(search);
    var submission_source = getSubmissionSource();
    var g4DataLayer = (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d === void 0 ? void 0 : _checkoutOrderV2$g4_d.g4_data_layer;
    var eventPayload = _objectSpread(_objectSpread({}, g4DataLayer), {}, {
      post_trim: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_ext,
      order_id: (_checkoutOrderV2$id = checkoutOrderV2.id) === null || _checkoutOrderV2$id === void 0 ? void 0 : _checkoutOrderV2$id.toString(),
      payment_status: "Success",
      inventory_type_string: (g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.inventory_type_string) || null,
      total_amount: parseFloat((_checkoutOrderV2$deta = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta === void 0 ? void 0 : (_checkoutOrderV2$deta2 = _checkoutOrderV2$deta.total_amount) === null || _checkoutOrderV2$deta2 === void 0 ? void 0 : _checkoutOrderV2$deta2.replace(/,/g, "")) || null,
      discount_code: ((_checkoutOrderV2$deta3 = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta3 === void 0 ? void 0 : _checkoutOrderV2$deta3.referral_code) || null,
      referral_location: submission_source
    });
    console.log("eventPayload.discount_code", eventPayload.discount_code);
    console.log("promoCode?.code", promoCode === null || promoCode === void 0 ? void 0 : promoCode.code);
    var promoData = promoCode !== null && promoCode !== void 0 && promoCode.code ? promoCode : getPromoCodeDataForTracking();
    var promoCodeData = getPromoEventParams(!eventPayload.discount_code || (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.discount_code) !== (promoData === null || promoData === void 0 ? void 0 : promoData.code));
    console.log("promoCodeData", promoCodeData);
    var isCreditCardOrder = typeof sessionStorage !== "undefined" && !!sessionStorage.getItem("cc_order_".concat(checkoutOrderV2.id));
    if (isCreditCardOrder) {
      trackEvents("credit_card_order_submit", {
        post_id: checkoutOrderV2.post_id,
        order_id: eventPayload.order_id,
        payment_method: values.paymentMethod || null,
        total_amount: eventPayload.total_amount,
        payment_status: "success",
        response_code: null,
        response_message: values.paymentMessage || null,
        inventory_type: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.inventory_type,
        post_make: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_make,
        post_model: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_model,
        post_year: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_year,
        post_condition: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_condition,
        post_price: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_price,
        platform: "web",
        referral_location: submission_source
      });
    } else {
      trackEvents("cash_order_submit", _objectSpread(_objectSpread({}, eventPayload), promoCodeData));
    }
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id]);

  //if (fetch_loading) return <Loader/>;

  return /*#__PURE__*/React.createElement(Layout, {
    hideFooter: true,
    headHideLinks: true,
    hideAppBanner: true,
    disableLoader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: isWebview ? "mt-4" : ""
  }, "   ", /*#__PURE__*/React.createElement(PaymentSuccess, {
    checkoutOrderV2: checkoutOrderV2
  })));
};
export default CheckoutSuccess;